import React from 'react';
import { useTranslation } from 'react-i18next';

const Privacy = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen mt-[78px] px-4 sm:px-6 lg:px-8">
      <div className="max-w-[1280px] mx-auto pt-[92px] pb-[100px] break-words whitespace-normal">
        {/* Header */}
        <div className="text-center mb-10">
          <h1 className="text-[48px] leading-[53px] font-normal libre-baskerville text-black">
            {t('privacy.title')}
          </h1>
        </div>

        {/* Introduction */}
        <div className="mb-10 space-y-4">
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('privacy.lastUpdated', { date: 'July 31, 2025' })}
          </p>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('privacy.content.intro')}
          </p>
        </div>

        {/* Section 1: Information We Collect */}
        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('privacy.sections.infoCollect')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium mb-4">
            {t('privacy.content.infoIntro')}
          </p>

          <div className="">
            <h3 className="text-[#474747] text-[16px] leading-[18px] font-medium">
              {t('privacy.subsections.deviceInfo')}
            </h3>
            <p className="text-[#474747] text-[16px] leading-[18px] font-medium ">
              {t('privacy.content.deviceIntro')}
            </p>
            <ul className="list-disc text-[#474747] text-[16px] leading-[18px] font-medium mb-4 pl-6">
              {(
                t('privacy.content.deviceList', { returnObjects: true }) || []
              ).map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>

            <h3 className="text-[#474747] text-[16px] leading-[18px] font-medium">
              {t('privacy.subsections.orderInfo')}
            </h3>
            <ul className="list-disc text-[#474747] text-[16px] leading-[18px] font-medium ml-6 mb-4">
              {(
                t('privacy.content.orderList', { returnObjects: true }) || []
              ).map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>

            <h3 className="text-[#474747] text-[16px] leading-[18px] font-medium">
              {t('privacy.subsections.supportInfo')}
            </h3>
            <p className="text-[#474747] text-[16px] leading-[18px] font-medium ">
              {t('privacy.content.supportIntro')}
            </p>
            <ul className="list-disc text-[#474747] text-[16px] leading-[18px] font-medium ml-6">
              {(
                t('privacy.content.supportList', { returnObjects: true }) || []
              ).map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </div>
        </section>

        {/* Section 2: How We Use Your Personal Information */}
        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('privacy.sections.howWeUse')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('privacy.content.useIntro')}
          </p>
          <ul className="list-disc text-[#474747] text-[16px] leading-[18px] font-medium ml-6">
            {(t('privacy.content.useList', { returnObjects: true }) || []).map(
              (item, idx) => (
                <li key={idx}>{item}</li>
              )
            )}
          </ul>
        </section>

        {/* Section 3: Sharing Your Personal Information */}
        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('privacy.sections.sharing')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('privacy.content.sharingIntro')}
          </p>
          <ul className="list-disc text-[#474747] text-[16px] leading-[18px] font-medium ml-6">
            {(
              t('privacy.content.sharingList', { returnObjects: true }) || []
            ).map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </section>

        {/* Section 4: Targeted Advertising */}
        <section className="mb-10 break-words whitespace-normal">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('privacy.sections.behavioralAds')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium mb-4">
            {t('privacy.content.behavioralIntro')}
          </p>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('privacy.content.behavioralOptoutIntro')}
          </p>
          <ul className="list-disc text-[#474747] text-[16px] leading-[18px] font-medium ml-6">
            {(
              t('privacy.content.behavioralOptoutList', {
                returnObjects: true,
              }) || []
            ).map((item, idx) => (
              <li key={idx} className={item.className || ''}>
                {item.text || item}
              </li>
            ))}
          </ul>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('privacy.content.behavioralOptoutOutro')}
          </p>
        </section>

        {/* Section 5: Your Rights */}
        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('privacy.sections.yourRights')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium mb-4">
            {t('privacy.content.rightsIntro')}
          </p>

          <h3 className="text-[#474747] text-[16px] leading-[18px] font-medium ">
            {t('privacy.subsections.gdpr')}
          </h3>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium mb-4">
            {t('privacy.content.gdprP1')}
          </p>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium mb-4">
            {t('privacy.content.gdprP2')}
          </p>

          <h3 className="text-[#474747] text-[16px] leading-[18px] font-medium ">
            {t('privacy.subsections.ccpa')}
          </h3>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium mb-4">
            {t('privacy.content.ccpaP')}
          </p>
        </section>

        {/* Section 6: Data Retention */}
        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('privacy.sections.dataRetention')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('privacy.content.dataRetention')}
          </p>
        </section>

        {/* Section 7: Security */}
        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('privacy.sections.security')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('privacy.content.security')}
          </p>
        </section>

        {/* Section 8: Changes to This Privacy Policy */}
        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('privacy.sections.changes')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('privacy.content.changes')}
          </p>
        </section>

        {/* Section 9: Contact Us */}
        <section className="mb-10">
          <h2 className="text-[28px] font-normal leading-[31px] libre-baskerville text-black mb-4">
            {t('privacy.sections.contact')}
          </h2>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium mb-4">
            {t('privacy.content.contactIntro')}
          </p>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('privacy.content.contactOrg')}
          </p>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('privacy.content.contactAddress')}
          </p>
          <p className="text-[#474747] text-[16px] leading-[18px] font-medium">
            {t('privacy.content.contactPhone')}
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
